export default __webpack_public_path__ + "static/media/wrong.7712bbb1.svg";